import styled from "styled-components";

export const MainSection = styled.section`
  overflow: hidden;
  .container {
    margin-top: 6rem;
    padding-bottom: 6rem;
  }

  .btns-div {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 2rem;
    margin-top: 1rem;

    @media (max-width: 991.98px) {
      justify-content: center;
    }

    img {
      cursor: pointer;
      height: 30px;
    }
  }

  .info-text {
    font-size: 12px;
    margin-top: 1rem;

    @media (max-width: 991.98px) {
      text-align: center;
      margin-bottom: 2rem;
    }
  }

  .first-br {
    @media (max-width: 991.98px) {
      display: none;
    }
  }
`;

export const Title = styled.h5`
  /* font-family: "Inter", sans-serif; */
  font-style: normal;
  font-weight: 400;
  font-size: 50px;
  line-height: 50px;
  /* identical to box height */

  text-transform: lowercase;

  color: rgba(3, 43, 136, 1);
  text-transform: capitalize;

  @media (max-width: 990px) {
    text-align: center;
    font-size: 40px;
  }
`;

export const Text = styled.p`
  font-family: "Catamaran";
  font-style: normal;
  font-weight: 300;
  font-size: 21px;
  line-height: 30px;
  text-transform: capitalize;
  color: #4d4d4d;
  margin-top: 1.5rem;

  @media (max-width: 990px) {
    text-align: center;
    font-size: 20px;
  }
`;

export const SwiperWrapper = styled.div`
  text-align: center;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;

  .swiper {
    width: 100%;
    /* padding-top: 50px; */
    padding-bottom: 50px;
  }

  .swiper-slide {
    background-position: center;
    background-size: cover;
    width: 250px;
    /* height: 300px; */
    /* box-shadow: 0 15px 50px rgba(0, 0, 0, 0.2); */
    filter: blur(2.5px);
  }

  .swiper-slide-active {
    filter: blur(0px);
  }

  .swiper-slide img {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 250px;
    height: 400px;
  }

  .swiper-3d {
    perspective: 552px;
  }

  .swiper-3d .swiper-slide-shadow-left {
    background-image: none;
  }

  .swiper-3d .swiper-slide-shadow-right {
    background-image: none;
  }

  .swiper-pagination-bullet {
    background: rgba(57, 88, 160, 1);
  }

  .swiper-pagination-bullet-active {
    background-color: rgba(3, 43, 136, 1);
  }

  .swiper-icon {
    font-size: 32px;
    color: rgba(3, 43, 136, 1) !important;
    cursor: pointer;
  }
`;
